import soundConfig from 'src/conf/soundConfig';
import { Ticker } from '../odie';
import { ParticlesPlugin } from './particles/ParticlesPlugin';
import sounds from 'src/lib/sounds';

class Resource {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public loadAssets(id: string | string[]) {
    // TODO
  }
}

type SoundPlayOptions = {
  volume?: number;
  pan?: number;
  dupes?: number; // max number of instances that can play at once
  rate?: number;
  dupesInterval?: number; // interval to decrease dupes instance count
};

class Sound {
  public volume = 0.25;

  // Record number of instances of each sound playing, similar to original implementation to avoid
  // playing the same sound too many times at once.
  private _instances: Record<string, number> = {};

  public play(id: string, opts?: SoundPlayOptions) {
    // if (!id.startsWith('puzzle-block-drop')) return;
    // Dupes prevent too many instances of the same sound playing at once.
    const dupes = opts?.dupes ?? 3;
    if (!this._instances[id]) this._instances[id] = 0;
    if (this._instances[id] >= dupes) return;
    this._instances[id] += 1;

    sounds.sfx.setVolume(id, (opts?.volume ?? 1) * this.volume);
    sounds.sfx.play(id);

    // Reset instance count after half second.
    setTimeout(() => {
      this._instances[id] -= 1;
    }, opts?.dupesInterval ?? 500);
  }

  public has(id: string) {
    return id in soundConfig.sfx;
  }
}

// Application class used in place of original implementation of the Application class.
class Match2App {
  public resource = new Resource();
  public particles = new ParticlesPlugin();
  public sound = new Sound();
  private _started = false;

  public start() {
    if (this._started) return;
    this._started = true;
    Ticker.system.add(this.update, this);
    Ticker.system.start();
  }

  public stop() {
    this._started = false;
    this.particles.destroyAll();
    Ticker.system.removeAllListeners();
    Ticker.system.stop();
  }

  public update() {
    this.particles.update();
  }
}

export const app = new Match2App();
